import { createNotify } from 'helpers/createNotify';

export const notifySuccess = (message: string): void => {
  createNotify(message);
};
